module.exports = {
	"code": 200,
	"status": "Success",
	"data": {
		"id": 3,
		"parent_id": 1,
		"name": "Main Category",
		"is_active": true,
		"position": 2,
		"level": 1,
		"product_count": 4021,
		"children_data": [
			{
				"id": 4,
				"parent_id": 3,
				"name": {
					"en": "Equipment",
					"th": "Equipment"
				},
				"is_active": true,
				"position": 1,
				"level": 2,
				"product_count": 382,
				"children_data": [
					{
						"id": 5,
						"parent_id": 4,
						"name": {
							"en": "Laces",
							"th": "Laces"
						},
						"is_active": true,
						"position": 1,
						"level": 3,
						"product_count": 177,
						"children_data": []
					},
					{
						"id": 6,
						"parent_id": 4,
						"name": {
							"en": "Shinpads",
							"th": "Shinpads"
						},
						"is_active": true,
						"position": 2,
						"level": 3,
						"product_count": 23,
						"children_data": []
					},
					{
						"id": 7,
						"parent_id": 4,
						"name": {
							"en": "Bags",
							"th": "Bags"
						},
						"is_active": true,
						"position": 3,
						"level": 3,
						"product_count": 45,
						"children_data": []
					},
					{
						"id": 8,
						"parent_id": 4,
						"name": {
							"en": "Balls",
							"th": "Balls"
						},
						"is_active": true,
						"position": 4,
						"level": 3,
						"product_count": 13,
						"children_data": []
					},
					{
						"id": 9,
						"parent_id": 4,
						"name": {
							"en": "Goalkeeper Gloves",
							"th": "Goalkeeper Gloves"
						},
						"is_active": true,
						"position": 5,
						"level": 3,
						"product_count": 90,
						"children_data": []
					},
					{
						"id": 10,
						"parent_id": 4,
						"name": {
							"en": "Kids",
							"th": "Kids"
						},
						"is_active": true,
						"position": 6,
						"level": 3,
						"product_count": 11,
						"children_data": []
					},
					{
						"id": 11,
						"parent_id": 4,
						"name": {
							"en": "Other",
							"th": "Other"
						},
						"is_active": true,
						"position": 7,
						"level": 3,
						"product_count": 15,
						"children_data": []
					},
					{
						"id": 12,
						"parent_id": 4,
						"name": {
							"en": "SALE",
							"th": "SALE"
						},
						"is_active": true,
						"position": 8,
						"level": 3,
						"product_count": 0,
						"children_data": []
					},
					{
						"id": 119,
						"parent_id": 4,
						"name": {
							"en": "Support",
							"th": "Support"
						},
						"is_active": true,
						"position": 9,
						"level": 3,
						"product_count": 19,
						"children_data": []
					}
				]
			},
			{
				"id": 13,
				"parent_id": 3,
				"name": {
					"en": "SALE",
					"th": "SALE"
				},
				"is_active": true,
				"position": 2,
				"level": 2,
				"product_count": 45,
				"children_data": []
			},
			{
				"id": 14,
				"parent_id": 3,
				"name": {
					"en": "Apparel",
					"th": "Apparel"
				},
				"is_active": true,
				"position": 3,
				"level": 2,
				"product_count": 764,
				"children_data": [
					{
						"id": 15,
						"parent_id": 14,
						"name": {
							"en": "Training Tops",
							"th": "Training Tops"
						},
						"is_active": true,
						"position": 1,
						"level": 3,
						"product_count": 139,
						"children_data": []
					},
					{
						"id": 16,
						"parent_id": 14,
						"name": {
							"en": "Polo Shirts",
							"th": "Polo Shirts"
						},
						"is_active": true,
						"position": 2,
						"level": 3,
						"product_count": 83,
						"children_data": []
					},
					{
						"id": 17,
						"parent_id": 14,
						"name": {
							"en": "T-Shirts",
							"th": "T-Shirts"
						},
						"is_active": true,
						"position": 3,
						"level": 3,
						"product_count": 173,
						"children_data": []
					},
					{
						"id": 18,
						"parent_id": 14,
						"name": {
							"en": "Accessories",
							"th": "Accessories"
						},
						"is_active": true,
						"position": 4,
						"level": 3,
						"product_count": 3,
						"children_data": []
					},
					{
						"id": 19,
						"parent_id": 14,
						"name": {
							"en": "Jogger Pants",
							"th": "Jogger Pants"
						},
						"is_active": true,
						"position": 5,
						"level": 3,
						"product_count": 22,
						"children_data": []
					},
					{
						"id": 20,
						"parent_id": 14,
						"name": {
							"en": "Shorts",
							"th": "Shorts"
						},
						"is_active": true,
						"position": 6,
						"level": 3,
						"product_count": 66,
						"children_data": []
					},
					{
						"id": 21,
						"parent_id": 14,
						"name": {
							"en": "Socks",
							"th": "Socks"
						},
						"is_active": true,
						"position": 7,
						"level": 3,
						"product_count": 145,
						"children_data": []
					},
					{
						"id": 22,
						"parent_id": 14,
						"name": {
							"en": "SALE",
							"th": "SALE"
						},
						"is_active": true,
						"position": 8,
						"level": 3,
						"product_count": 0,
						"children_data": []
					},
					{
						"id": 92,
						"parent_id": 14,
						"name": {
							"en": "Base Layer",
							"th": "Base Layer"
						},
						"is_active": true,
						"position": 9,
						"level": 3,
						"product_count": 62,
						"children_data": []
					},
					{
						"id": 93,
						"parent_id": 14,
						"name": {
							"en": "Snapback",
							"th": "Snapback"
						},
						"is_active": true,
						"position": 10,
						"level": 3,
						"product_count": 0,
						"children_data": [
							{
								"id": 94,
								"parent_id": 93,
								"name": {
									"en": "Hats",
									"th": "Hats"
								},
								"is_active": true,
								"position": 1,
								"level": 4,
								"product_count": 2,
								"children_data": []
							}
						]
					},
					{
						"id": 95,
						"parent_id": 14,
						"name": {
							"en": "Hats",
							"th": "Hats"
						},
						"is_active": true,
						"position": 11,
						"level": 3,
						"product_count": 14,
						"children_data": []
					},
					{
						"id": 98,
						"parent_id": 14,
						"name": {
							"en": "Training Shorts",
							"th": "Training Shorts"
						},
						"is_active": true,
						"position": 12,
						"level": 3,
						"product_count": 12,
						"children_data": []
					},
					{
						"id": 99,
						"parent_id": 14,
						"name": {
							"en": "Jackets",
							"th": "Jackets"
						},
						"is_active": true,
						"position": 13,
						"level": 3,
						"product_count": 22,
						"children_data": []
					},
					{
						"id": 100,
						"parent_id": 14,
						"name": {
							"en": "Kids",
							"th": "Kids"
						},
						"is_active": true,
						"position": 14,
						"level": 3,
						"product_count": 29,
						"children_data": []
					}
				]
			},
			{
				"id": 23,
				"parent_id": 3,
				"name": {
					"en": "Boots",
					"th": "Boots"
				},
				"is_active": true,
				"position": 4,
				"level": 2,
				"product_count": 1797,
				"children_data": [
					{
						"id": 24,
						"parent_id": 23,
						"name": {
							"en": "Mizuno",
							"th": "Mizuno"
						},
						"is_active": true,
						"position": 1,
						"level": 3,
						"product_count": 126,
						"children_data": [
							{
								"id": 25,
								"parent_id": 24,
								"name": {
									"en": "Morelia",
									"th": "Morelia"
								},
								"is_active": true,
								"position": 1,
								"level": 4,
								"product_count": 60,
								"children_data": []
							},
							{
								"id": 29,
								"parent_id": 24,
								"name": {
									"en": "Basara",
									"th": "Basara"
								},
								"is_active": true,
								"position": 2,
								"level": 4,
								"product_count": 10,
								"children_data": []
							},
							{
								"id": 30,
								"parent_id": 24,
								"name": {
									"en": "Morelia Neo",
									"th": "Morelia Neo"
								},
								"is_active": true,
								"position": 3,
								"level": 4,
								"product_count": 31,
								"children_data": []
							},
							{
								"id": 31,
								"parent_id": 24,
								"name": {
									"en": "Monarchida",
									"th": "Monarchida"
								},
								"is_active": true,
								"position": 4,
								"level": 4,
								"product_count": 10,
								"children_data": []
							},
							{
								"id": 126,
								"parent_id": 24,
								"name": {
									"en": "Rebula",
									"th": "Rebula"
								},
								"is_active": true,
								"position": 5,
								"level": 4,
								"product_count": 15,
								"children_data": []
							}
						]
					},
					{
						"id": 26,
						"parent_id": 23,
						"name": {
							"en": "Ground Type",
							"th": "Ground Type"
						},
						"is_active": true,
						"position": 2,
						"level": 3,
						"product_count": 1797,
						"children_data": [
							{
								"id": 27,
								"parent_id": 26,
								"name": {
									"en": "Firm Ground",
									"th": "Firm Ground"
								},
								"is_active": true,
								"position": 1,
								"level": 4,
								"product_count": 1590,
								"children_data": []
							},
							{
								"id": 46,
								"parent_id": 26,
								"name": {
									"en": "Turf & Indoor Court",
									"th": "Turf & Indoor Court"
								},
								"is_active": true,
								"position": 2,
								"level": 4,
								"product_count": 180,
								"children_data": []
							},
							{
								"id": 52,
								"parent_id": 26,
								"name": {
									"en": "Artificial Ground",
									"th": "Artificial Ground"
								},
								"is_active": true,
								"position": 3,
								"level": 4,
								"product_count": 27,
								"children_data": []
							}
						]
					},
					{
						"id": 28,
						"parent_id": 23,
						"name": {
							"en": "Ari Exclusive",
							"th": "Ari Exclusive"
						},
						"is_active": true,
						"position": 3,
						"level": 3,
						"product_count": 509,
						"children_data": []
					},
					{
						"id": 32,
						"parent_id": 23,
						"name": {
							"en": "Puma",
							"th": "Puma"
						},
						"is_active": true,
						"position": 4,
						"level": 3,
						"product_count": 178,
						"children_data": [
							{
								"id": 33,
								"parent_id": 32,
								"name": {
									"en": "evoSPEED",
									"th": "evoSPEED"
								},
								"is_active": true,
								"position": 1,
								"level": 4,
								"product_count": 39,
								"children_data": []
							},
							{
								"id": 35,
								"parent_id": 32,
								"name": {
									"en": "evoPOWER",
									"th": "evoPOWER"
								},
								"is_active": true,
								"position": 2,
								"level": 4,
								"product_count": 63,
								"children_data": []
							},
							{
								"id": 36,
								"parent_id": 32,
								"name": {
									"en": "evoTOUCH",
									"th": "evoTOUCH"
								},
								"is_active": true,
								"position": 3,
								"level": 4,
								"product_count": 40,
								"children_data": []
							},
							{
								"id": 37,
								"parent_id": 32,
								"name": {
									"en": "KING",
									"th": "KING"
								},
								"is_active": true,
								"position": 4,
								"level": 4,
								"product_count": 20,
								"children_data": []
							},
							{
								"id": 123,
								"parent_id": 32,
								"name": {
									"en": "ONE",
									"th": "ONE"
								},
								"is_active": true,
								"position": 5,
								"level": 4,
								"product_count": 16,
								"children_data": []
							}
						]
					},
					{
						"id": 34,
						"parent_id": 23,
						"name": {
							"en": "Kids",
							"th": "Kids"
						},
						"is_active": true,
						"position": 5,
						"level": 3,
						"product_count": 116,
						"children_data": []
					},
					{
						"id": 38,
						"parent_id": 23,
						"name": {
							"en": "Nike",
							"th": "Nike"
						},
						"is_active": true,
						"position": 6,
						"level": 3,
						"product_count": 621,
						"children_data": [
							{
								"id": 39,
								"parent_id": 38,
								"name": {
									"en": "Magista",
									"th": "Magista"
								},
								"is_active": true,
								"position": 1,
								"level": 4,
								"product_count": 151,
								"children_data": []
							},
							{
								"id": 40,
								"parent_id": 38,
								"name": {
									"en": "Hypervenom",
									"th": "Hypervenom"
								},
								"is_active": true,
								"position": 2,
								"level": 4,
								"product_count": 176,
								"children_data": []
							},
							{
								"id": 41,
								"parent_id": 38,
								"name": {
									"en": "Mercurial",
									"th": "Mercurial"
								},
								"is_active": true,
								"position": 3,
								"level": 4,
								"product_count": 204,
								"children_data": []
							},
							{
								"id": 42,
								"parent_id": 38,
								"name": {
									"en": "Tiempo",
									"th": "Tiempo"
								},
								"is_active": true,
								"position": 4,
								"level": 4,
								"product_count": 90,
								"children_data": []
							},
							{
								"id": 97,
								"parent_id": 38,
								"name": {
									"en": "CR7",
									"th": "CR7"
								},
								"is_active": true,
								"position": 5,
								"level": 4,
								"product_count": 21,
								"children_data": []
							}
						]
					},
					{
						"id": 43,
						"parent_id": 23,
						"name": {
							"en": "adidas",
							"th": "adidas"
						},
						"is_active": true,
						"position": 7,
						"level": 3,
						"product_count": 872,
						"children_data": [
							{
								"id": 44,
								"parent_id": 43,
								"name": {
									"en": "Copa",
									"th": "Copa"
								},
								"is_active": true,
								"position": 1,
								"level": 4,
								"product_count": 115,
								"children_data": []
							},
							{
								"id": 45,
								"parent_id": 43,
								"name": {
									"en": "Tango",
									"th": "Tango"
								},
								"is_active": true,
								"position": 2,
								"level": 4,
								"product_count": 124,
								"children_data": []
							},
							{
								"id": 47,
								"parent_id": 43,
								"name": {
									"en": "Messi",
									"th": "Messi"
								},
								"is_active": true,
								"position": 3,
								"level": 4,
								"product_count": 84,
								"children_data": []
							},
							{
								"id": 48,
								"parent_id": 43,
								"name": {
									"en": "X",
									"th": "X"
								},
								"is_active": true,
								"position": 4,
								"level": 4,
								"product_count": 283,
								"children_data": []
							},
							{
								"id": 49,
								"parent_id": 43,
								"name": {
									"en": "ACE",
									"th": "ACE"
								},
								"is_active": true,
								"position": 5,
								"level": 4,
								"product_count": 287,
								"children_data": []
							},
							{
								"id": 50,
								"parent_id": 43,
								"name": {
									"en": "adidas Classics",
									"th": "adidas Classics"
								},
								"is_active": true,
								"position": 6,
								"level": 4,
								"product_count": 28,
								"children_data": []
							},
							{
								"id": 114,
								"parent_id": 43,
								"name": {
									"en": "Nemeziz",
									"th": "Nemeziz"
								},
								"is_active": true,
								"position": 7,
								"level": 4,
								"product_count": 65,
								"children_data": []
							},
							{
								"id": 122,
								"parent_id": 43,
								"name": {
									"en": "Nemeziz Messi",
									"th": "Nemeziz Messi"
								},
								"is_active": true,
								"position": 8,
								"level": 4,
								"product_count": 28,
								"children_data": []
							}
						]
					},
					{
						"id": 51,
						"parent_id": 23,
						"name": {
							"en": "New Arrivals",
							"th": "New Arrivals"
						},
						"is_active": true,
						"position": 8,
						"level": 3,
						"product_count": 333,
						"children_data": []
					}
				]
			},
			{
				"id": 53,
				"parent_id": 3,
				"name": {
					"en": "Printing Character",
					"th": "Printing Character"
				},
				"is_active": true,
				"position": 5,
				"level": 2,
				"product_count": 81,
				"children_data": []
			},
			{
				"id": 54,
				"parent_id": 3,
				"name": {
					"en": "Printing Number",
					"th": "Printing Number"
				},
				"is_active": true,
				"position": 6,
				"level": 2,
				"product_count": 30,
				"children_data": []
			},
			{
				"id": 55,
				"parent_id": 3,
				"name": {
					"en": "Prename Set",
					"th": "Prename Set"
				},
				"is_active": true,
				"position": 7,
				"level": 2,
				"product_count": 240,
				"children_data": []
			},
			{
				"id": 56,
				"parent_id": 3,
				"name": {
					"en": "Badge",
					"th": "Badge"
				},
				"is_active": true,
				"position": 8,
				"level": 2,
				"product_count": 3,
				"children_data": []
			},
			{
				"id": 57,
				"parent_id": 3,
				"name": {
					"en": "Kit",
					"th": "Kit"
				},
				"is_active": true,
				"position": 9,
				"level": 2,
				"product_count": 768,
				"children_data": [
					{
						"id": 58,
						"parent_id": 57,
						"name": {
							"en": "Thai League",
							"th": "Thai League"
						},
						"is_active": true,
						"position": 1,
						"level": 3,
						"product_count": 452,
						"children_data": [
							{
								"id": 59,
								"parent_id": 58,
								"name": {
									"en": "Buriram United",
									"th": "Buriram United"
								},
								"is_active": true,
								"position": 1,
								"level": 4,
								"product_count": 25,
								"children_data": []
							},
							{
								"id": 60,
								"parent_id": 58,
								"name": {
									"en": "Bangkok United",
									"th": "Bangkok United"
								},
								"is_active": true,
								"position": 2,
								"level": 4,
								"product_count": 90,
								"children_data": []
							},
							{
								"id": 61,
								"parent_id": 58,
								"name": {
									"en": "Sisaket FC",
									"th": "Sisaket FC"
								},
								"is_active": true,
								"position": 3,
								"level": 4,
								"product_count": 48,
								"children_data": []
							},
							{
								"id": 62,
								"parent_id": 58,
								"name": {
									"en": "Ratchaburi Mitr Phol FC",
									"th": "Ratchaburi Mitr Phol FC"
								},
								"is_active": true,
								"position": 4,
								"level": 4,
								"product_count": 48,
								"children_data": []
							},
							{
								"id": 63,
								"parent_id": 58,
								"name": {
									"en": "Pattaya United",
									"th": "Pattaya United"
								},
								"is_active": true,
								"position": 5,
								"level": 4,
								"product_count": 27,
								"children_data": []
							},
							{
								"id": 64,
								"parent_id": 58,
								"name": {
									"en": "SCG Muangthong Utd",
									"th": "SCG Muangthong Utd"
								},
								"is_active": true,
								"position": 6,
								"level": 4,
								"product_count": 21,
								"children_data": []
							},
							{
								"id": 65,
								"parent_id": 58,
								"name": {
									"en": "Navy FC",
									"th": "Navy FC"
								},
								"is_active": true,
								"position": 7,
								"level": 4,
								"product_count": 12,
								"children_data": []
							},
							{
								"id": 66,
								"parent_id": 58,
								"name": {
									"en": "Thai Honda Ladkrabang FC",
									"th": "Thai Honda Ladkrabang FC"
								},
								"is_active": true,
								"position": 8,
								"level": 4,
								"product_count": 12,
								"children_data": []
							},
							{
								"id": 67,
								"parent_id": 58,
								"name": {
									"en": "Nakhonratchasima Mazda FC",
									"th": "Nakhonratchasima Mazda FC"
								},
								"is_active": true,
								"position": 9,
								"level": 4,
								"product_count": 15,
								"children_data": []
							},
							{
								"id": 68,
								"parent_id": 58,
								"name": {
									"en": "Suphanburi FC",
									"th": "Suphanburi FC"
								},
								"is_active": true,
								"position": 10,
								"level": 4,
								"product_count": 15,
								"children_data": []
							},
							{
								"id": 69,
								"parent_id": 58,
								"name": {
									"en": "Port FC",
									"th": "Port FC"
								},
								"is_active": true,
								"position": 11,
								"level": 4,
								"product_count": 15,
								"children_data": []
							},
							{
								"id": 70,
								"parent_id": 58,
								"name": {
									"en": "Bangkok Glass",
									"th": "Bangkok Glass"
								},
								"is_active": true,
								"position": 12,
								"level": 4,
								"product_count": 12,
								"children_data": []
							},
							{
								"id": 71,
								"parent_id": 58,
								"name": {
									"en": "Ubon UMT United",
									"th": "Ubon UMT United"
								},
								"is_active": true,
								"position": 13,
								"level": 4,
								"product_count": 19,
								"children_data": []
							},
							{
								"id": 72,
								"parent_id": 58,
								"name": {
									"en": "Chiangrai United",
									"th": "Chiangrai United"
								},
								"is_active": true,
								"position": 14,
								"level": 4,
								"product_count": 18,
								"children_data": []
							},
							{
								"id": 73,
								"parent_id": 58,
								"name": {
									"en": "Chonburi FC",
									"th": "Chonburi FC"
								},
								"is_active": true,
								"position": 15,
								"level": 4,
								"product_count": 12,
								"children_data": []
							},
							{
								"id": 74,
								"parent_id": 58,
								"name": {
									"en": "Other Thai Teams",
									"th": "Other Thai Teams"
								},
								"is_active": true,
								"position": 16,
								"level": 4,
								"product_count": 46,
								"children_data": []
							},
							{
								"id": 118,
								"parent_id": 58,
								"name": {
									"en": "Other Thai Team",
									"th": "Other Thai Team"
								},
								"is_active": true,
								"position": 17,
								"level": 4,
								"product_count": 18,
								"children_data": []
							}
						]
					},
					{
						"id": 75,
						"parent_id": 57,
						"name": {
							"en": "International",
							"th": "International"
						},
						"is_active": true,
						"position": 2,
						"level": 3,
						"product_count": 83,
						"children_data": [
							{
								"id": 76,
								"parent_id": 75,
								"name": {
									"en": "Germany",
									"th": "Germany"
								},
								"is_active": true,
								"position": 1,
								"level": 4,
								"product_count": 14,
								"children_data": []
							},
							{
								"id": 77,
								"parent_id": 75,
								"name": {
									"en": "Thailand",
									"th": "Thailand"
								},
								"is_active": true,
								"position": 2,
								"level": 4,
								"product_count": 63,
								"children_data": []
							},
							{
								"id": 78,
								"parent_id": 75,
								"name": {
									"en": "Japan",
									"th": "Japan"
								},
								"is_active": true,
								"position": 3,
								"level": 4,
								"product_count": 6,
								"children_data": []
							}
						]
					},
					{
						"id": 79,
						"parent_id": 57,
						"name": {
							"en": "European League",
							"th": "European League"
						},
						"is_active": true,
						"position": 3,
						"level": 3,
						"product_count": 82,
						"children_data": [
							{
								"id": 80,
								"parent_id": 79,
								"name": {
									"en": "AC Milan",
									"th": "AC Milan"
								},
								"is_active": true,
								"position": 1,
								"level": 4,
								"product_count": 5,
								"children_data": []
							},
							{
								"id": 81,
								"parent_id": 79,
								"name": {
									"en": "Real Madrid",
									"th": "Real Madrid"
								},
								"is_active": true,
								"position": 2,
								"level": 4,
								"product_count": 26,
								"children_data": []
							},
							{
								"id": 82,
								"parent_id": 79,
								"name": {
									"en": "Juventus",
									"th": "Juventus"
								},
								"is_active": true,
								"position": 3,
								"level": 4,
								"product_count": 6,
								"children_data": []
							},
							{
								"id": 83,
								"parent_id": 79,
								"name": {
									"en": "Barcelona",
									"th": "Barcelona"
								},
								"is_active": true,
								"position": 4,
								"level": 4,
								"product_count": 15,
								"children_data": []
							},
							{
								"id": 84,
								"parent_id": 79,
								"name": {
									"en": "Paris St Germain",
									"th": "Paris St Germain"
								},
								"is_active": true,
								"position": 5,
								"level": 4,
								"product_count": 7,
								"children_data": []
							},
							{
								"id": 116,
								"parent_id": 79,
								"name": {
									"en": "Borussia Dortmund",
									"th": "Borussia Dortmund"
								},
								"is_active": true,
								"position": 6,
								"level": 4,
								"product_count": 8,
								"children_data": []
							},
							{
								"id": 117,
								"parent_id": 79,
								"name": {
									"en": "Bayern Munich",
									"th": "Bayern Munich"
								},
								"is_active": true,
								"position": 7,
								"level": 4,
								"product_count": 15,
								"children_data": []
							}
						]
					},
					{
						"id": 85,
						"parent_id": 57,
						"name": {
							"en": "English League",
							"th": "English League"
						},
						"is_active": true,
						"position": 4,
						"level": 3,
						"product_count": 139,
						"children_data": [
							{
								"id": 86,
								"parent_id": 85,
								"name": {
									"en": "Leicester City",
									"th": "Leicester City"
								},
								"is_active": true,
								"position": 1,
								"level": 4,
								"product_count": 5,
								"children_data": []
							},
							{
								"id": 87,
								"parent_id": 85,
								"name": {
									"en": "Manchester City",
									"th": "Manchester City"
								},
								"is_active": true,
								"position": 2,
								"level": 4,
								"product_count": 9,
								"children_data": []
							},
							{
								"id": 88,
								"parent_id": 85,
								"name": {
									"en": "Arsenal",
									"th": "Arsenal"
								},
								"is_active": true,
								"position": 3,
								"level": 4,
								"product_count": 17,
								"children_data": []
							},
							{
								"id": 89,
								"parent_id": 85,
								"name": {
									"en": "Liverpool",
									"th": "Liverpool"
								},
								"is_active": true,
								"position": 4,
								"level": 4,
								"product_count": 33,
								"children_data": []
							},
							{
								"id": 90,
								"parent_id": 85,
								"name": {
									"en": "Chelsea",
									"th": "Chelsea"
								},
								"is_active": true,
								"position": 5,
								"level": 4,
								"product_count": 10,
								"children_data": []
							},
							{
								"id": 91,
								"parent_id": 85,
								"name": {
									"en": "Manchester United",
									"th": "Manchester United"
								},
								"is_active": true,
								"position": 6,
								"level": 4,
								"product_count": 40,
								"children_data": []
							},
							{
								"id": 124,
								"parent_id": 85,
								"name": {
									"en": "Tottenham Hotspur",
									"th": "Tottenham Hotspur"
								},
								"is_active": true,
								"position": 7,
								"level": 4,
								"product_count": 10,
								"children_data": []
							},
							{
								"id": 127,
								"parent_id": 85,
								"name": {
									"en": "West Ham United",
									"th": "West Ham United"
								},
								"is_active": true,
								"position": 8,
								"level": 4,
								"product_count": 5,
								"children_data": []
							},
							{
								"id": 128,
								"parent_id": 85,
								"name": {
									"en": "Everton",
									"th": "Everton"
								},
								"is_active": true,
								"position": 9,
								"level": 4,
								"product_count": 10,
								"children_data": []
							}
						]
					},
					{
						"id": 125,
						"parent_id": 57,
						"name": {
							"en": "Others",
							"th": "Others"
						},
						"is_active": true,
						"position": 5,
						"level": 3,
						"product_count": 12,
						"children_data": []
					},
					{
						"id": 146,
						"parent_id": 57,
						"name": {
							"en": "New Arrivals",
							"th": "New Arrivals"
						},
						"is_active": true,
						"position": 6,
						"level": 3,
						"product_count": 15,
						"children_data": []
					}
				]
			},
			{
				"id": 96,
				"parent_id": 3,
				"name": {
					"en": "Boots Stitching",
					"th": "Boots Stitching"
				},
				"is_active": true,
				"position": 10,
				"level": 2,
				"product_count": 10,
				"children_data": []
			},
			{
				"id": 101,
				"parent_id": 3,
				"name": {
					"en": "Ari Gear",
					"th": "Ari Gear"
				},
				"is_active": true,
				"position": 11,
				"level": 2,
				"product_count": 548,
				"children_data": [
					{
						"id": 102,
						"parent_id": 101,
						"name": {
							"en": "Laces",
							"th": "Laces"
						},
						"is_active": true,
						"position": 1,
						"level": 3,
						"product_count": 115,
						"children_data": []
					},
					{
						"id": 103,
						"parent_id": 101,
						"name": {
							"en": "Other",
							"th": "Other"
						},
						"is_active": true,
						"position": 2,
						"level": 3,
						"product_count": 4,
						"children_data": []
					},
					{
						"id": 104,
						"parent_id": 101,
						"name": {
							"en": "Bags",
							"th": "Bags"
						},
						"is_active": true,
						"position": 3,
						"level": 3,
						"product_count": 22,
						"children_data": []
					},
					{
						"id": 105,
						"parent_id": 101,
						"name": {
							"en": "Training Tops",
							"th": "Training Tops"
						},
						"is_active": true,
						"position": 4,
						"level": 3,
						"product_count": 34,
						"children_data": []
					},
					{
						"id": 106,
						"parent_id": 101,
						"name": {
							"en": "Polo Shirts",
							"th": "Polo Shirts"
						},
						"is_active": true,
						"position": 5,
						"level": 3,
						"product_count": 65,
						"children_data": []
					},
					{
						"id": 107,
						"parent_id": 101,
						"name": {
							"en": "T-Shirts",
							"th": "T-Shirts"
						},
						"is_active": true,
						"position": 6,
						"level": 3,
						"product_count": 107,
						"children_data": []
					},
					{
						"id": 108,
						"parent_id": 101,
						"name": {
							"en": "Accessories",
							"th": "Accessories"
						},
						"is_active": true,
						"position": 7,
						"level": 3,
						"product_count": 2,
						"children_data": []
					},
					{
						"id": 109,
						"parent_id": 101,
						"name": {
							"en": "Jogger Pants",
							"th": "Jogger Pants"
						},
						"is_active": true,
						"position": 8,
						"level": 3,
						"product_count": 22,
						"children_data": []
					},
					{
						"id": 110,
						"parent_id": 101,
						"name": {
							"en": "Shorts",
							"th": "Shorts"
						},
						"is_active": true,
						"position": 9,
						"level": 3,
						"product_count": 43,
						"children_data": []
					},
					{
						"id": 111,
						"parent_id": 101,
						"name": {
							"en": "Socks",
							"th": "Socks"
						},
						"is_active": true,
						"position": 10,
						"level": 3,
						"product_count": 61,
						"children_data": []
					},
					{
						"id": 112,
						"parent_id": 101,
						"name": {
							"en": "Kids",
							"th": "Kids"
						},
						"is_active": true,
						"position": 11,
						"level": 3,
						"product_count": 7,
						"children_data": []
					},
					{
						"id": 113,
						"parent_id": 101,
						"name": {
							"en": "Training Shorts",
							"th": "Training Shorts"
						},
						"is_active": true,
						"position": 12,
						"level": 3,
						"product_count": 3,
						"children_data": []
					},
					{
						"id": 115,
						"parent_id": 101,
						"name": {
							"en": "Base Layer",
							"th": "Base Layer"
						},
						"is_active": true,
						"position": 13,
						"level": 3,
						"product_count": 50,
						"children_data": []
					},
					{
						"id": 129,
						"parent_id": 101,
						"name": {
							"en": "JATURAMITR",
							"th": "JATURAMITR"
						},
						"is_active": true,
						"position": 14,
						"level": 3,
						"product_count": 0,
						"children_data": [
							{
								"id": 130,
								"parent_id": 129,
								"name": {
									"en": "Accessories",
									"th": "Accessories"
								},
								"is_active": true,
								"position": 1,
								"level": 4,
								"product_count": 0,
								"children_data": []
							},
							{
								"id": 131,
								"parent_id": 129,
								"name": {
									"en": "Bags",
									"th": "Bags"
								},
								"is_active": true,
								"position": 2,
								"level": 4,
								"product_count": 0,
								"children_data": []
							},
							{
								"id": 132,
								"parent_id": 129,
								"name": {
									"en": "Snapback",
									"th": "Snapback"
								},
								"is_active": true,
								"position": 3,
								"level": 4,
								"product_count": 0,
								"children_data": [
									{
										"id": 133,
										"parent_id": 132,
										"name": {
											"en": "Hats",
											"th": "Hats"
										},
										"is_active": true,
										"position": 1,
										"level": 5,
										"product_count": 0,
										"children_data": []
									}
								]
							},
							{
								"id": 134,
								"parent_id": 129,
								"name": {
									"en": "Scarfs",
									"th": "Scarfs"
								},
								"is_active": true,
								"position": 4,
								"level": 4,
								"product_count": 0,
								"children_data": []
							},
							{
								"id": 135,
								"parent_id": 129,
								"name": {
									"en": "Polo Shirts",
									"th": "Polo Shirts"
								},
								"is_active": true,
								"position": 5,
								"level": 4,
								"product_count": 0,
								"children_data": []
							},
							{
								"id": 136,
								"parent_id": 129,
								"name": {
									"en": "Training Tops",
									"th": "Training Tops"
								},
								"is_active": true,
								"position": 6,
								"level": 4,
								"product_count": 0,
								"children_data": []
							},
							{
								"id": 137,
								"parent_id": 129,
								"name": {
									"en": "Jerseys",
									"th": "Jerseys"
								},
								"is_active": true,
								"position": 7,
								"level": 4,
								"product_count": 0,
								"children_data": []
							}
						]
					}
				]
			},
			{
				"id": 138,
				"parent_id": 3,
				"name": {
					"en": "JATURAMITR",
					"th": "JATURAMITR"
				},
				"is_active": true,
				"position": 12,
				"level": 2,
				"product_count": 300,
				"children_data": [
					{
						"id": 139,
						"parent_id": 138,
						"name": {
							"en": "Accessories",
							"th": "Accessories"
						},
						"is_active": true,
						"position": 1,
						"level": 3,
						"product_count": 24,
						"children_data": []
					},
					{
						"id": 140,
						"parent_id": 138,
						"name": {
							"en": "Bags",
							"th": "Bags"
						},
						"is_active": true,
						"position": 2,
						"level": 3,
						"product_count": 8,
						"children_data": []
					},
					{
						"id": 141,
						"parent_id": 138,
						"name": {
							"en": "Hats",
							"th": "Hats"
						},
						"is_active": true,
						"position": 3,
						"level": 3,
						"product_count": 8,
						"children_data": []
					},
					{
						"id": 142,
						"parent_id": 138,
						"name": {
							"en": "Scarfs",
							"th": "Scarfs"
						},
						"is_active": true,
						"position": 4,
						"level": 3,
						"product_count": 16,
						"children_data": []
					},
					{
						"id": 143,
						"parent_id": 138,
						"name": {
							"en": "Polo Shirts",
							"th": "Polo Shirts"
						},
						"is_active": true,
						"position": 5,
						"level": 3,
						"product_count": 96,
						"children_data": []
					},
					{
						"id": 144,
						"parent_id": 138,
						"name": {
							"en": "Training Tops",
							"th": "Training Tops"
						},
						"is_active": true,
						"position": 6,
						"level": 3,
						"product_count": 72,
						"children_data": []
					},
					{
						"id": 145,
						"parent_id": 138,
						"name": {
							"en": "Jerseys",
							"th": "Jerseys"
						},
						"is_active": true,
						"position": 7,
						"level": 3,
						"product_count": 76,
						"children_data": []
					}
				]
			}
		],
		"lang": "en"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/apis/magentoCategories.json
// module id = 2098
// module chunks = 0